import services from "@/http";
import * as types from "./mutation-types";
import { LocalStorage } from "@/helpers/functions/localStorage";

import { merge } from "lodash";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetConselhos", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search = {}) => {
  try {
    const { data } = await services.conselhos.get_all(search);
    return data;
  } catch (error) {
    return {
      data: [],
      meta: {},
    };
  }
};

function getFormatedKey(user = {}) {
  const userId = "id" in user ? user.id : -1
  const clientId = "cliente_id" in user ? user.cliente_id : -1;
  return `@app/conselhos/select/${clientId}_${userId}`
}

export const ActionResetStoredItemsToSelect = async ({ rootGetters }) => {
  try {
    const user = rootGetters["auth/GetUser"];
    const formatedKey = getFormatedKey(user);
    const savedItemsToSelect = LocalStorage(formatedKey);
    savedItemsToSelect.delete();
  } catch (error) {}
};

export const ActionFindToSelect = async ({ rootGetters }, payload) => {
  const user = rootGetters["auth/GetUser"];
  const formatedKey = getFormatedKey(user);
  const savedItemsToSelect = LocalStorage(formatedKey);

  if (savedItemsToSelect.has) {
    return savedItemsToSelect.getItem;
  }

  try {
    const { data } = await services.conselhos.get_all(payload);
    savedItemsToSelect.store(data);
    return data;
  } catch (error) {
    return {
      data: [],
      meta: {},
    };
  }
};

export const ActionShow = async ({ dispatch }, id) => {
  let default_conselho = await dispatch("ActionNewConselho");

  await services.conselhos.show({ id: id }).then((res) => {
    let conselho = res.data.conselho;
    if (!conselho.endereco) {
      conselho.endereco = default_conselho.endereco;
    }

    if (!conselho.contatos) {
      conselho.contatos = default_conselho.contatos;
    }

    dispatch("ActionSetConselho", conselho);
  });
};

export const ActionSave = async ({ dispatch, rootGetters }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }

  dispatch("ActionResetStoredItemsToSelect");
};

export const ActionStore = async ({ commit }, payload) => {
  await services.conselhos.store(payload).then((res) => {
    commit(types.SET_CONSELHO, res.data.conselho);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.conselhos.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_CONSELHO, res.data.conselho);
  });
};

export const ActionDelete = async ({ commit, dispatch }, id) => {
  await services.conselhos.delete({ id: id }).then(() => {
    commit(types.SET_CONSELHO, null);
    dispatch("ActionResetStoredItemsToSelect");
  });
};

export const ActionSetConselhos = ({ commit }, payload) => {
  commit(types.SET_CONSELHOS, payload);
};

export const ActionSetConselho = ({ commit, getters }, payload) => {
  if (!payload.config) {
    payload.config = getters.configDefault;
  }
  payload.config = merge(getters.configDefault, payload.config);
  commit(types.SET_CONSELHO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewConselho = ({ commit }) => {
  commit(types.SET_CONSELHO, { mandatos: [] });
};

export const ActionLoadLayout = async ({ commit }, id) => {
  await services.conselhos.show_layout({ id: id }).then(({ data }) => {
    commit(types.SET_LAYOUT, data.conselho_layout);
  });
};

export const ActionSaveLayout = async ({ commit }, payload) => {
  await services.conselhos
    .update_layout({ id: payload.conselho_id }, payload)
    .then(({ data }) => {
      commit(types.SET_LAYOUT, data.conselho_layout);
    });
};

export const ActionGetDashboard = async ({ dispatch }, payload) => {
  try {
    const { data } = await services.conselhos.dashboard(payload);
    return data;
  } catch (error) {
    return {};
  }
};
